export default function SocialShare () {
  const WRAPPERS = document.querySelectorAll('.social-share')
  if (WRAPPERS.length > 0) {
    for (let i = 0; i < WRAPPERS.length; i++) {
      const share = new Share(WRAPPERS[i])
    }
  }
}

class Share {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.SOCIAL_BUTTON = WRAPPER.querySelector('.social-share__button')
    this.SOCIAL_WRAP = WRAPPER.querySelector('.social-share__wrap')
    this.SOCIAL_ICONS = WRAPPER.querySelectorAll('.social-share__icon')
    this.NETWORKS = {
      facebook: { width: 600, height: 300 },
      twitter: { width: 600, height: 254 },
      linkedin: { width: 600, height: 473 }
    };

    (this.SOCIAL_BUTTON && this.SOCIAL_WRAP) && this.buttonEventListener()
    this.SOCIAL_ICONS.length > 0 && this.iconEventListeners()
  }

  buttonEventListener () {
    this.SOCIAL_BUTTON.addEventListener('click', () => this.SOCIAL_WRAP.classList.toggle('show'))
  }

  iconEventListeners () {
    for (let i = 0; i < this.SOCIAL_ICONS.length; i++) {
      const ICON = this.SOCIAL_ICONS[i]

      ICON.addEventListener('click', (e) => {
        e.preventDefault()

        const HREF = ICON.getAttribute('href')
        const OPTIONS = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,'
        const NETWORK = ICON.getAttribute('data-network')

        window.open(HREF, '', OPTIONS + 'height=' + this.NETWORKS[NETWORK].height + ',width=' + this.NETWORKS[NETWORK].width)
      })
    }
  }
}
